import React, { useEffect } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  useNavigate,
  Navigate
} from 'react-router-dom';

import LayoutRoutes from '../Route/LayoutRoutes';
import Signin from '../Auth/Signin';
import PrivateRoute from './PrivateRoute';
import { authRoutes } from './AuthRoutes';

function AuthRedirectWrapper({ children }) {
  const HOMEPAGE = process.env.REACT_APP_HOMEPAGE || '/dashboard';
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const isAuthenticated = !!localStorage.getItem('accessToken');
    const publicPaths = ['/login', '/register'];

    if (!isAuthenticated && !publicPaths.includes(pathname)) {
      navigate('/login', { replace: true });
    } else if (isAuthenticated && publicPaths.includes(pathname)) {
       navigate(HOMEPAGE || '/', { replace: true });
    }
  }, [pathname, navigate, HOMEPAGE]);

  return <>{children}</>;
}

const Routers = () => {
  const login = JSON.parse(localStorage.getItem('login'));

  return (
    <BrowserRouter basename={'/'}>
      <AuthRedirectWrapper>
        <Routes>
          <Route path={'/'} element={<PrivateRoute />}>
            {login || localStorage.getItem('accessToken') ? (
              <>
                <Route exact path={`${process.env.PUBLIC_URL}`} element={<Navigate to={`${process.env.PUBLIC_URL}/dashboard`} />} />
                <Route exact path={`/`} element={<Navigate to={`${process.env.PUBLIC_URL}/dashboard`} />} />
              </>
            ) : ( '' )}
            <Route path={`/*`} element={<LayoutRoutes />} />
          </Route>
          <Route exact path={`${process.env.PUBLIC_URL || ''}/login`} element={<Signin />} />
          {authRoutes.map(({ path, Component }, i) => (
            <Route path={path} element={<Component />} key={i} />
          ))}
        </Routes>
      </AuthRedirectWrapper>
    </BrowserRouter>
  );
};

export default Routers;
